import { render } from "./ElectronicClassCard.vue?vue&type=template&id=bc1ae054&scoped=true"
import script from "./ElectronicClassCard.vue?vue&type=script&lang=js"
export * from "./ElectronicClassCard.vue?vue&type=script&lang=js"

import "./ElectronicClassCard.vue?vue&type=style&index=0&id=bc1ae054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1ae054"]])

export default __exports__